import { render, staticRenderFns } from "./certificatesDialog.vue?vue&type=template&id=4ed0b138&scoped=true"
import script from "./certificatesDialog.vue?vue&type=script&lang=js"
export * from "./certificatesDialog.vue?vue&type=script&lang=js"
import style0 from "./certificatesDialog.vue?vue&type=style&index=0&id=4ed0b138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0b138",
  null
  
)

export default component.exports